import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import MenuList from "../../components/RestaurantMenuPage/MenuList/MenuList";
import Navbar from "../../components/shared/AppNavbar/AppNavbar";
import { ApiResponse } from "../../interfaces/ApiResponse";
import { CategoryItem, Restaurant } from "../../interfaces/Catalogue";
import { catalogueApi } from "../../services/catalogueApi";
import "./SubMenuPage.scss";
import { shopApi } from "../../services/apiGate";
import { useSelector } from "react-redux";
import { loyalityApi } from "../../services/loyalityApi";
import { RootState } from "../../store/rootState";

const SubMenuPage = () => {
  const menuPage = true;
  const navigate = useNavigate();
  const location = useLocation();
  const userInfo = useSelector((state: any) => state.auth.userInfo);
  const { restaurantId, categoryId, menuId,  menuName } = useParams();
  const selectedMode = useSelector(
    (state: RootState) => state.app.selectedMode
  );
  const [subMenus, setSubMenus] = useState<CategoryItem[] | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [restaurant, setRestaurant] = useState<Restaurant>();
  const [userLoyalityPoints, setUserLoyalityPoints] = useState(0);

  useEffect(() => {
    const fetchRestaurant = async () => {
      try {
        const response = await shopApi.getResturantById({
          id: Number(restaurantId),
          diningMode: Number(selectedMode),
          adresse: {
            latitude: 0,
            longitude: 0,
          },
        });
        if (menuId && categoryId) {
          fetchSubMenus(categoryId, menuId, response.data?.restaurant.id);
        }
        setRestaurant(response.data?.restaurant);
      } catch (error) {
        console.error("Error fetching restaurant:", error);
      }
    };

    if (restaurantId) {
      fetchRestaurant();
    }
  }, [restaurantId]);

  useEffect(() => {
    const fetchClientData = async () => {
      if (!restaurant) return;

      try {
        const res = await loyalityApi.getClientBySecretCode(
          userInfo?.qrCodeValue,
          restaurant.id
        );

        setUserLoyalityPoints(res?.data?.loyalityPoints);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (userInfo?.qrCodeValue) {
      fetchClientData();
    }
  }, [restaurant]);

  const fetchSubMenus = async (
    categoryId: string,
    menuId: string,
    restaurantId: number
  ) => {
    try {
      setLoading(true);
      const response: { data: ApiResponse<CategoryItem[]> } =
        await catalogueApi.GetSubMenu(
          Number(categoryId),
          String(menuId),
          restaurantId
        );
      const result = response.data.data.result;
      setSubMenus(result);
    } catch (error: any) {
      console.error("🚀 ~ fetchCategoryDetails ~ error:", error);
      // const { response } = error;
      // const errorCodeFI = response?.data?.failureResponse?.codeFI?.code;
      // const errorCodeReq = response?.status;
      // setError(errorCodeFI || errorCodeReq);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div id="subMenuPage">
      <Navbar menuPage={menuPage} />
      <div className="BodyPage">
        <div className="submenu-header">
          <div className="navigation">
            <ArrowBackIcon
              style={{ cursor: "pointer" }}
              onClick={() => {
                navigate(`/restaurant/${restaurantId}`);
              }}
            />

            <div>
              <div className="submenu-details">
                <p className="submenu-name">{menuName}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="">
          <MenuList
            loading={loading}
            categoryItems={subMenus}
            categoryId={Number(categoryId)}
            restaurantLogo={restaurant?.imageUrl || ""}
            isSubMenu={true}
            restaurantId={restaurant?.id}
            userLoyalityPoints={userLoyalityPoints}
          />
        </div>
      </div>
    </div>
  );
};

export default SubMenuPage;
